import React from "react";
import { StandardDialog } from "./modals";
import { DeleteIcon } from "./elements/forms/FormDomain";
import { XCircleIcon } from "@heroicons/react/24/solid";

/**
 * @param {{ title: string, question: string, description: string, onSuccess: () => void, onFailure: () => void, open: boolean }}
 * @returns {JSX.Element}
 */
export const ConfirmAction = ({ title, question, description, open, onSuccess, onFailure }) => {

  return (
    <StandardDialog open={open} onClose={onFailure}>
      <div className="bg-white rounded-3xl flex flex-col justify-center items-center px-3 py-2 space-y-10">
        <div className="text-center space-y-4">
          <h1 className="font-bold text-3xl text-gray-600">{title}</h1>
          <h4 className="text-sm font-medium text-gray-500">{question}</h4>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
        <div className="flex items-center justify-center space-x-3">
          <button onClick={onFailure} className='flex items-center justify-center space-x-2 border border-general-teal text-general-teal bg-white rounded-full px-4 hover:bg-teal-50 py-2 w-[250px] transition-colors'>
            <span>Refuser</span>
            <XCircleIcon className="h-6" />
          </button>
          <button onClick={onSuccess} className='flex items-center justify-center space-x-2 border border-general-pink text-white bg-general-pink/90 rounded-full px-4 py-2 w-[250px] hover:bg-general-pink transition-colors'>
            <span>Accepter</span>
            <DeleteIcon className="h-6" />
          </button>
        </div>
      </div>
    </StandardDialog>
  );
};